jQuery(document).ready(function ($) {
    const videos = $('.single__video--thumbnail');

    $.fn.toggleVideo = function () {
        this.hide();
        this.next().show();

        return this;
    }

    videos.on('click', function (event) {
        //const $embed = $(this).next('.single__video--embed');

        $(this).toggleVideo();

        /*

        if (!$embed.data('loaded')) {
            $embed.data('loaded', true);
            const existing = $embed.find('script[src]')[0];
            if (existing) {
                const src = existing.src;
                existing.parentNode.removeChild(existing);
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        const s = document.createElement('script');
                        s.src = src;
                        s.type = 'text/javascript';
                        s.onload = function () {
                            window.dispatchEvent(new Event('resize'));
                        };
                        $embed[0].appendChild(s);
                    });
                });
            }
        }

         */
    });
});